module.exports = __webpack_public_path__ + "media/icons/skrzynia-manualna-white@3x-d2961de0.svg";